"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// For the purposes of correctly mocking the window object in Jest,
// this is a safe way of returning it for tests to work as expected.
function getWindow() {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') {
    throw new Error('window not available');
  }

  return window;
}